import React from "react";
import SmallRichText from "components/small-rich-text";

const tdWidth = (index) => {
    if (index === 0) return "w-[245px]";
    if (index === 1) return "w-[500px]";
    return "w-[509px]";
};

const Headers = ({ headers }) => (
    <tr>
        {headers.map((header, index) => (
            <th className={tdWidth(index)} key={header._key}>
                <SmallRichText value={header?.data} />
            </th>
        ))}
    </tr>
);

const Body = ({ rows }) => (
    <>
        {rows.map((row) => (
            <tr key={row._key}>
                {row.columns.map((column, index) => (
                    <td className={tdWidth(index)} key={column._key}>
                        <SmallRichText value={column?.data} />
                    </td>
                ))}
            </tr>
        ))}
    </>
);

const GenericTable = ({ data }) => (
    <div className="overflow-auto">
        <h2 className="text-center text-blue-700 mb-7"> 
            {data?.title}
        </h2>
        <table className="w-[1250px]">
            <tbody>
                <Headers headers={data?.headers} />    
                <Body rows={data?.rows} />
            </tbody>
        </table>
    </div>
);

export default GenericTable;
